import React from 'react';
import moment from 'moment';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import NotesContainer from 'clientProfile/components/BasicProfile/Notes';
import ShowTags from 'clientProfile/components/BasicProfile/ShowTags';

class BWClientHeader extends React.Component {
  static defaultProps = { editClient: null };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let patchDate;
    if (this.props.client && this.props.client.patch_test_date) {
      patchDate = this.props.client.patch_test_date;
    } else if (this.props.editClient && this.props.editClient.response) {
      patchDate = this.props.editClient.response.patch_test_date;
    }

    const months = moment().diff(moment(patchDate), 'days');

    return (
      <div data-bem="BWClientHeader" data-tag={fromAnyToTrimmed(this.props.tag)} className="bw-client-header">
        <div>
          <h2 className="f-b">{this.props.client.user_name} </h2>
          <div className="client-prompt-buttons 2">
            <div className="prompt-item">
              {((!this.props.client.phone && !this.props.editClient) ||
                (this.props.editClient && this.props.editClient.response && !this.props.editClient.response.phone)) && (
                <div
                  className="prompt"
                  tabIndex="0"
                  role="button"
                  onClick={this.props.goToEditClientProfile || alwaysNoop}
                >
                  no mobile
                </div>
              )}{' '}
            </div>
            {!this.props.client.phone && <div className="prompt-item dot">•</div>}

            <div className="prompt-item">
              {' '}
              {this.props.client && this.props.client.birthday && (
                <small>
                  Birthday {this.props.client.birthday[0]} {moment.monthsShort(this.props.client.birthday[1] - 1)}
                </small>
              )}
              {this.props.client &&
                !this.props.client.birthday &&
                this.props.editClient &&
                this.props.editClient.response &&
                this.props.editClient.response.birthday && (
                  <small>
                    Birthday {this.props.editClient.response.birthday[0]}{' '}
                    {moment.monthsShort(this.props.editClient.response.birthday[1] - 1)}
                  </small>
                )}
              {((!this.props.client.birthday && !this.props.editClient) ||
                (this.props.editClient &&
                  this.props.editClient.response &&
                  !this.props.editClient.response.birthday)) && (
                <div
                  className="prompt"
                  tabIndex="0"
                  role="button"
                  onClick={this.props.goToEditClientProfile || alwaysNoop}
                >
                  no birthday
                </div>
              )}
            </div>
            <div className="prompt-item dot">•</div>
            <div className="prompt-item">
              {this.props.client.patch_test_date ||
              (this.props.editClient &&
                this.props.editClient.response &&
                this.props.editClient.response.patch_test_date) ? (
                <>
                  {months >= 182 ? (
                    <div className="prompt" tabIndex="0" role="button" onClick={this.props.goToPatchView || alwaysNoop}>
                      patch test expired
                    </div>
                  ) : (
                    <> Patch test {moment(patchDate).format('D MMM YYYY')} </>
                  )}
                </>
              ) : (
                <div className="prompt" tabIndex="0" role="button" onClick={this.props.goToPatchView || alwaysNoop}>
                  no patch test
                </div>
              )}
            </div>
          </div>
        </div>

        {fromAnyToBool(this.props.clientTags) && <ShowTags tagList={this.props.clientTags} />}
        {fromAnyToBool(this.props.client.notes) && <NotesContainer notes={this.props.client.notes} />}

        <div
          role="button"
          tabIndex="0"
          className="btn btn-violet-link"
          onClick={this.props.goToClientProfile}
          style={{ display: 'inline-block' }}
        >
          View profile
        </div>
        {this.props.noShow}
      </div>
    );
  }
}

export default BWClientHeader;
